import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function UserLogin({ onLogin, onSwitchToSignup, onSwitchToForgotPassword, onCancel }) {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/user/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        // Store user data in localStorage
        localStorage.setItem('userAuth', JSON.stringify(result.user));

        // If user is admin, authenticate against the admin endpoint to get a JWT token
        if (result.user?.role === 'admin') {
          try {
            const adminResponse = await fetch(`${API_URL}/admin/login`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                username: formData.email,
                password: formData.password
              }),
            });
            const adminResult = await adminResponse.json();
            if (adminResult.success && adminResult.token) {
              localStorage.setItem('adminToken', adminResult.token);
              localStorage.setItem('adminUser', JSON.stringify(adminResult.user));
              localStorage.setItem('adminAuth', JSON.stringify({
                authenticated: true,
                username: adminResult.user?.email || formData.email,
                timestamp: new Date().toISOString()
              }));
            }
          } catch (adminErr) {
            console.error('Admin token fetch failed:', adminErr);
          }
        }

        onLogin(result.user);
      } else {
        setError(result.message || 'Login failed');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '30px' }}>
          Login to Your Account
        </h2>

        {error && (
          <div style={{
            backgroundColor: '#ffebee',
            color: '#c62828',
            padding: '12px',
            borderRadius: '5px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '14px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                marginBottom: '15px'
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '14px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                marginBottom: '20px'
              }}
            />
          </div>

          <div style={{ textAlign: 'right', marginBottom: '15px' }}>
            <span
              onClick={onSwitchToForgotPassword}
              style={{
                color: '#e74c3c',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                textDecoration: 'underline'
              }}
            >
              Forgot Password?
            </span>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="submit-btn"
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: loading ? '#95a5a6' : '#27ae60',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              marginBottom: '15px'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>
            Don't have an account?{' '}
            <span
              onClick={onSwitchToSignup}
              style={{
                color: '#3498db',
                cursor: 'pointer',
                fontWeight: 'bold',
                textDecoration: 'underline'
              }}
            >
              Sign Up
            </span>
          </div>

          {onCancel && (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button
                type="button"
                onClick={onCancel}
                style={{
                  backgroundColor: 'transparent',
                  color: '#7f8c8d',
                  border: '1px solid #bdc3c7',
                  padding: '10px 24px',
                  borderRadius: '5px',
                  fontSize: '14px',
                  cursor: 'pointer',
                  fontWeight: '500',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#ecf0f1';
                  e.target.style.borderColor = '#95a5a6';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderColor = '#bdc3c7';
                }}
              >
                ← Back to Home
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default UserLogin;
